import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { FiArrowLeft, FiCalendar } from 'react-icons/fi';
import axiosClient from '../../api/axiosClient';
import styles from './BlogPostDetail.module.css';

const API_ORIGIN = (process.env.REACT_APP_API_URL || 'http://localhost:5000/api').replace(/\/api$/, '');

const BlogPostDetail: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [post, setPost] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    axiosClient.get(`/content/blog-posts/${id}`)
      .then(({ data }) => setPost(data.post))
      .catch(() => setNotFound(true))
      .finally(() => setLoading(false));
  }, [id]);

  return (
    <div className={styles.page}>
      <div className={styles.topBar}>
        <Link to="/" className={styles.brand}>
          <img src="/images/logo.png" alt="BCT" className={styles.brandLogo} />
          <span>Block Cost Technologies</span>
        </Link>
        <Link to="/#blog" className={styles.backLink}><FiArrowLeft /> Back to Insights</Link>
      </div>

      {loading && <div className={styles.stateMsg}>Loading…</div>}
      {!loading && notFound && <div className={styles.stateMsg}>This post couldn't be found — it may have been removed.</div>}

      {!loading && post && (
        <article className={styles.article}>
          <span className={styles.category}>{post.category}</span>
          <h1>{post.title}</h1>
          <div className={styles.meta}><FiCalendar /> {new Date(post.created_at).toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: 'numeric' })}</div>

          {post.image_path && (
            <div className={styles.heroImgWrap}>
              <img src={`${API_ORIGIN}${post.image_path}`} alt={post.title} />
            </div>
          )}

          {post.description && <p className={styles.lead}>{post.description}</p>}

          {post.content ? (
            <div className={styles.content}>
              {post.content.split('\n').filter(Boolean).map((para: string, i: number) => <p key={i}>{para}</p>)}
            </div>
          ) : (
            <p className={styles.content}>Full article content coming soon.</p>
          )}

          <Link to="/#blog" className={styles.bottomBack}><FiArrowLeft /> Back to all insights</Link>
        </article>
      )}
    </div>
  );
};

export default BlogPostDetail;
